import { TextField } from "@mui/material";

const NumericField = (props) => {
    const handleWheel = (e) => {
      // Empêcher le changement de valeur sur le défilement
      e.target.blur();
    };
  
    return (
      <TextField
        {...props}
        InputProps={{
          ...props.InputProps,
          inputProps: {
            ...props.InputProps?.inputProps,
            onWheel: handleWheel
          }
        }}
      />
    );
  };

  export default NumericField;
